import { render, staticRenderFns } from "./GenerateWhoIsOnboard.vue?vue&type=template&id=4688ff6c&scoped=true&"
import script from "./GenerateWhoIsOnboard.vue?vue&type=script&lang=js&"
export * from "./GenerateWhoIsOnboard.vue?vue&type=script&lang=js&"
import style0 from "./GenerateWhoIsOnboard.vue?vue&type=style&index=0&id=4688ff6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4688ff6c",
  null
  
)

export default component.exports